var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#151515;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,6.8C14.9,6.8,6.8,15,6.8,25c0,7.7,4.8,14.4,11.7,17c-0.2-1.4-0.4-3.5,0-5.1c0.6-2.6,2.2-9.2,2.2-9.2 S20,26.3,20,24.9c0-1.4,0.9-4.3,3.3-4.3c2.5,0,2.3,2.4,2.3,2.6c0,0.3,0,0.5-0.1,1.2c-0.3,1.2-0.8,3-1.3,4.5 c-0.8,2.4,1.2,3.6,2.6,3.6c0.9,0,2.5-0.3,3.8-1.9c1-1.3,1.9-3.2,1.9-6.4c0-2.8-1.2-4.6-2.6-5.8c-1.9-1.6-4.5-1.6-5-1.6 c-1.3,0-3.2,0.3-4.8,1.4c-1.8,1.2-3.3,3.7-3.3,6.4c0,2.4,1.2,4,1.5,4.3c0.3,0.3-0.5,2.5-0.5,2.5s-0.1,0.5-0.6,0.1 c-0.6-0.3-3.6-2.4-3.6-7.1s3.4-10.8,12-10.8c3.7,0,6.3,1.4,8.1,3.1c2.4,2.2,3,5.2,3,7.5c0,5.5-3.4,11.1-9.4,11.1 c-2.1,0-3.8-1.2-4.2-2.1l-1.1,4.2c0,0-0.7,2.5-2.4,5c1.7,0.6,3.6,0.9,5.5,0.9c10.1,0,18.2-8.2,18.2-18.2C43.2,15,35.1,6.8,25,6.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.c1f2dc65c1806e587365e7cd0de2c12a.svg";
export { ForwardRef as ReactComponent };